// noinspection ES6PreferShortImport

import { MaybeNull, RecordType } from '@petconsole/pure-base';
import { anySite } from '../../constants';
import entityAttributes from '../../entity/entityAttributes';
import { entityCategory, entityName, entityTabName } from '../../entity/constants';
import entitySchema from '../../entity/entitySchema';
import initialEntity from '../../entity/initialEntity';
import { schema } from '../../entity/schema';
import { DataEntityType, InitialEntity, RatingBusinessColumns, SubscribeColumns } from '../../types';

interface BusBuilder extends RatingBusinessColumns, SubscribeColumns {
  type: DataEntityType;
  busBuilderId: string;
  name: string;
}

const { General, Details, Avatar, Banner, Photos, Comments, Preview } = entityTabName;
export const busBuilderEntity = entityAttributes({
  name: entityName.busBuilder,
  attributes: {
    category: entityCategory.business,
    columns: { address: true, business: true, rating: true, socials: true, subscribe: true },
    loadLimit: 20,
    maxImages: 12,
    restrictGet: false,
    site: anySite.busConsole,
    subscribable: true,
    tabs: [General, Details, Avatar, Banner, Photos, Comments, Preview],
  },
});

const { strim } = schema;
export const busBuilderSchema = entitySchema<BusBuilder>(busBuilderEntity, {
  name: strim().required('Business name is required'),
});

export const busBuilderDefaults: Partial<BusBuilder> = {
  name: '',
};

export interface BusBuilderRecord extends BusBuilder, RecordType {}

export type MaybeBusBuilderRecord = MaybeNull<BusBuilderRecord>;
export type BusBuilderRecords = BusBuilderRecord[];

export const initialBusBuilder: InitialEntity<BusBuilder, BusBuilderRecord> = (overrides = {}) =>
  initialEntity<BusBuilder>(busBuilderEntity, { ...busBuilderDefaults, ...overrides }) as BusBuilderRecord;
